import { HeaderMenu } from 'types';

export const headerMenuItemsEn: HeaderMenu[] = [
    { path: '/#programs', title: 'agenda', dataAtSelector: 'headerAgendaLink', isAnchor: true },
    { path: '/#speakers', title: 'speakers', dataAtSelector: 'headerSpeakersLink', isAnchor: true },
    // { path: '/papers', title: 'speakers', dataAtSelector: 'headerSpeakersLink' },
    // { path: '/registration', title: 'registration', dataAtSelector: 'headerRegistrationLink' },
    // { path: '/sponsors', title: 'sponsors', dataAtSelector: 'headerSponsorsLink' },
    { path: '/code', title: 'code', dataAtSelector: 'headerCodeLink' },
    { path: '/location', title: 'location', dataAtSelector: 'headerLocationLink' },
    { path: '/media', title: 'media', dataAtSelector: 'mediaLink' },
];
